import { Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { ProfilePricingTable } from '../../models/Profile'
import { fetchPricingTable } from '../../services/ProfileBillingService'

interface PricingTableProps {
  profileSlug: string
}

export const PricingTable: React.FC<PricingTableProps> = ({ profileSlug }) => {
  const [data, setData] = useState<ProfilePricingTable | undefined>(undefined)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    setIsLoading(true)
    fetchPricingTable(profileSlug)
      .then((pricingTable) => setData(pricingTable))
      .finally(() => setIsLoading(false))
  }, [])

  if (isLoading || !data) {
    return <Spin />
  }

  return (
    <stripe-pricing-table
      pricing-table-id={data.pricingTableId}
      publishable-key={data.publishableKey}
      client-reference-id={profileSlug}
      customer-session-client-secret={data.customerSession}
    />
  )
}

export type PricingTableType = { PricingTable: typeof PricingTable }
